// Imports
import { z } from 'zod';


/** Removes a specific persisted form entry from the browser's history state */
export default function removePersistedFormEntry(recoverableKey: string) {
	// Type the history state object
	const persistedStateSchema = z
		.object({
			state: z.object({
				persistentForm: z.record(z.record(z.unknown())),
			}),
		})
		.deepPartial()
		.nullable();
	
	const typedHistoryState = persistedStateSchema.parse(window.history.state);
	
	
	// Remove values persisted from the form
	if (typedHistoryState?.state?.persistentForm) {
		// Destructure the value from the existing persisted forms
		const { [recoverableKey]: _ignore, ...everythingElse } = typedHistoryState.state.persistentForm;
		
		
		// Assign the remaining values back to the persisted forms
		typedHistoryState.state.persistentForm = everythingElse;
		
		window.history.replaceState(typedHistoryState, '');
	}
}
